import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useFlightLoadingDetails } from "@apac/hooks";
import { trackEvent } from "@hopper-b2b/api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { AIR_ENTRY } from "@hopper-b2b/types";
import { LoadingScreen } from "@hsbc/portal";
import { getAirEntryProperties } from "@hsbc/utilities";

export const FlightListLoading = ({ isLoading }) => {
  const { t } = useI18nContext();

  const airEntryProperties = useSelector(getAirEntryProperties);

  useEffect(() => {
    if (!airEntryProperties.origin || !airEntryProperties.destination) return;
    trackEvent({
      eventName: AIR_ENTRY,
      properties: { ...airEntryProperties },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [airEntryProperties.origin, airEntryProperties.destination]);

  const {
    context,
    handlers: { onCancelClick },
  } = useFlightLoadingDetails();

  return (
    <LoadingScreen
      isLoading={isLoading}
      flightLoadingDetails={context}
      onCancelClick={onCancelClick}
      loadingSteps={[{ title: t("flightSearchLoadingText") }]}
    />
  );
};
